/* eslint-disable no-unused-vars */
import React, { useContext, useState } from 'react';
import PropTypes from 'prop-types';
import 'src/App.scss';
import JSONPretty from 'react-json-pretty';
var JSONPrettyMon = require('react-json-pretty/dist/monikai');

import { ReactComponent as Get } from 'src/assets/icons/get.svg';
import { ReactComponent as Send } from 'src/assets/icons/send.svg';
import { ReactComponent as Login } from 'src/assets/icons/log/login.svg';
import { ReactComponent as Logout } from 'src/assets/icons/log/logout.svg';
import { ReactComponent as Close } from 'src/assets/icons/close.svg';
import { ReactComponent as Check } from 'src/assets/icons/check.svg';
import { ReactComponent as Erase } from 'src/assets/icons/erase.svg';
import { ReactComponent as Whatsapp } from 'src/assets/icons/whatsapp.svg';
import DefIcon from 'src/assets/base/page.svg';

import { LogContext } from './LogProvider';
import { isValid } from 'src/services/auth';
import showToast from './toastyService';

const proxyUrl = window.globalConfig.PROXY_URL;
import axios from 'axios';

export default function LogScreen({ onClose }) {
  const empLogo = localStorage.getItem('empLogo');
  const usuario = localStorage.getItem('nomeUsuario');

  const cpf = localStorage.getItem('cpf');
  const senha = localStorage.getItem('senha');
  const loginErp = localStorage.getItem('loginErp');
  const senhaErp = localStorage.getItem('senhaErp');

  const { logData, setLogData } = useContext(LogContext);
  const [response, setResponse] = useState();
  const [payload, setPayload] = useState();
  const [showModal, setShowModal] = useState(false);
  const [copyShow, setCopyShow] = useState(false);

  const [filtro, setFiltro] = useState('');

  const customTheme = {
    main: 'color: #007e98; background:#f9f9f9;', // Fundo
    key: 'color: #004c5b;', // Chaves
    string: 'color: #c96800;', // Strings
    value: 'color: #b80900;', // Valores
    boolean: 'color: #99008c;', // Booleanos
    number: 'color: #4d0099;', // Números
  };

  function LogCache(porta) {
    const cache = JSON.parse(localStorage.getItem('cache')) || [];
  }

  async function SendViaPastebin(mydata) {
    try {
      const response = await axios.post(
        `${proxyUrl}/https://pastebin.com/api/api_post.php`,
        new URLSearchParams({
          api_dev_key: 'uWxtzIpOQm61_no4gjArOBTqghGH7MyR',
          api_paste_code: mydata,
          api_option: 'paste',
        }),
        {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        }
      );

      return String(response.data).replace(
        'pastebin.com/',
        'pastebin.com/raw/'
      );
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className="logscreen">
      <div className="logdebug" style={{ display: 'none' }}>
        <button onClick={() => LogCache()}>Debug Cache</button>
        <button onClick={() => localStorage.clear()}>Clear Cache</button>
      </div>

      <button className="closeButton" onClick={onClose}>
        <Close />
      </button>

      {isValid(showModal) && (
        <div className="modal absoluteCenter">
          <button
            onClick={() => {
              setShowModal('');
            }}
            className="close"
          >
            <Close />
          </button>

          {showModal === 'response' && (
            <span>
              <JSONPretty
                id="json-pretty"
                data={JSON.stringify(response, null, 2)
                  .replace(new RegExp(loginErp, 'gi'), '*****')
                  .replace(new RegExp(senhaErp, 'gi'), '*****')
                  .replace(new RegExp(senha, 'gi'), '*****')
                  .replace(new RegExp(cpf, 'gi'), '*****')
                  .replace(new RegExp(usuario, 'gi'), '*****')}
                theme={customTheme}
              ></JSONPretty>
            </span>
          )}
          {showModal === 'payload' && (
            <span>
              <JSONPretty
                id="json-pretty"
                data={JSON.stringify(payload, null, 2)
                  .replace(new RegExp(loginErp, 'gi'), '*****')
                  .replace(new RegExp(senhaErp, 'gi'), '*****')
                  .replace(new RegExp(senha, 'gi'), '*****')
                  .replace(new RegExp(cpf, 'gi'), '*****')
                  .replace(new RegExp(usuario, 'gi'), '*****')}
                theme={customTheme}
              ></JSONPretty>
            </span>
          )}
          <div className="footer">
            <button
              className="copy"
              onClick={async () => {
                const data = JSON.stringify(
                  showModal === 'payload' ? payload : response,
                  null,
                  2
                )
                  .replace(new RegExp(loginErp, 'gi'), '*****')
                  .replace(new RegExp(senhaErp, 'gi'), '*****')
                  .replace(new RegExp(senha, 'gi'), '*****')
                  .replace(new RegExp(cpf, 'gi'), '*****')
                  .replace(new RegExp(usuario, 'gi'), '*****');

                const url = await SendViaPastebin(data);
                if (url) {
                  const whatsappUrl = `https://wa.me/?text=${encodeURIComponent('*Confira os dados aqui:* ' + url)}`;
                  window.open(whatsappUrl);
                } else {
                  showToast('error', 'Erro ao enviar');
                }
              }}
            >
              <Whatsapp />
              Enviar
            </button>
            <button
              className="copy"
              onClick={() => {
                showModal === 'response'
                  ? navigator.clipboard.writeText(
                      JSON.stringify(response)
                        .replace(new RegExp(loginErp, 'gi'), '*****')
                        .replace(new RegExp(senhaErp, 'gi'), '*****')
                        .replace(new RegExp(senha, 'gi'), '*****')
                        .replace(new RegExp(cpf, 'gi'), '*****')
                        .replace(new RegExp(usuario, 'gi'), '*****')
                    )
                  : navigator.clipboard.writeText(
                      JSON.stringify(payload)
                        .replace(new RegExp(loginErp, 'gi'), '*****')
                        .replace(new RegExp(senhaErp, 'gi'), '*****')
                        .replace(new RegExp(senha, 'gi'), '*****')
                        .replace(new RegExp(cpf, 'gi'), '*****')
                        .replace(new RegExp(usuario, 'gi'), '*****')
                    );

                setCopyShow(true);
                setTimeout(() => {
                  setCopyShow(false);
                }, 1500);
              }}
            >
              copiar conteúdo
              <span className={copyShow ? 'show' : 'hide'}> Copiado! </span>
            </button>
          </div>
        </div>
      )}

      <div className="lista">
        {logData.length > 0 &&
          logData.map((item, index) => {
            if (
              !isValid(filtro) ||
              Object.values(item).some(
                (value) =>
                  value &&
                  value.toString().toLowerCase().includes(filtro.toLowerCase())
              ) ||
              usuario.toLowerCase().includes(filtro.toLowerCase())
            )
              return (
                <span className={`item ${item.status}`} key={index}>
                  <div className="status">
                    {item.icon === 'login' && <Login />}
                    {item.icon === 'logout' && <Logout />}
                    {item.icon === 'get' && <Get />}
                    {item.icon === 'send' && <Send />}
                  </div>

                  <div className="profile">
                    <label> {item.hora} </label>
                    {usuario}
                    <span className="img">
                      <img
                        src={empLogo}
                        onError={(e) => {
                          e.currentTarget.src = DefIcon;
                        }}
                      />
                    </span>
                  </div>

                  <p>
                    {item.msg} | Origem: {item.origem}
                  </p>

                  <div className="footer">
                    <button
                      onClick={() => {
                        setShowModal('payload');
                        setPayload(item.payload);
                      }}
                      className={`${item.status}`}
                    >
                      payload
                    </button>
                    <button
                      onClick={() => {
                        setShowModal('response');
                        setResponse(item.response);
                      }}
                      className={`${item.status}`}
                    >
                      response
                    </button>
                  </div>
                </span>
              );
          })}
      </div>

      <span className="search">
        <button onClick={() => setFiltro('error')} title="Ver Erros">
          <Close />
        </button>
        <button onClick={() => setFiltro('success')} title="Ver Sucessos">
          <Check />
        </button>
        <button onClick={() => setFiltro('')} title="Limpar">
          <Erase />
        </button>
        <input
          type="text"
          placeholder="Pesquisar"
          onChange={(e) => setFiltro(e.target.value)}
          onFocus={(e) => e.target.select()}
        />
      </span>
    </div>
  );
}

LogScreen.propTypes = {
  onClose: PropTypes.func.isRequired,
};
